import React from 'react';
import classNames from 'classnames';
import './Animator.css';

export default class Animator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animating: false,
      position: Animator.CENTER,
      animatePrepare: false,
    };
    this.animationCallback = null;
    this.postPrepareTimeout = null;
    this.startAnimation = this.startAnimation.bind(this);
    this.postPrepareAnimation = this.postPrepareAnimation.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);
  }

  componentDidMount() {
    this.startAnimation(this.props.position);
    if (this.node) {
      this.node.addEventListener('transitionend', this.onTransitionEnd);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.position !== this.props.position) {
      this.startAnimation(newProps.position, newProps.animationCallback);
    }
  }

  componentWillUnmount() {
    if (this.node) {
      this.node.removeEventListener('transitionend', this.onTransitionEnd);
    }
  }

  onTransitionEnd(e) {
    if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
    const callback = this.animationCallback;
    delete this.animationCallback;
    if (callback) setTimeout(callback, 0);
    else this.setState({ animating: false });
  }

  startAnimation(position, callback) {
    const noAnimate = position === Animator.CENTER;
    const animatingOut = [Animator.TO_LEFT, Animator.TO_RIGHT, Animator.TO_FADE].includes(position);
    const currentlyIn = [Animator.CENTER, Animator.FROM_LEFT, Animator.FROM_RIGHT, Animator.FROM_FADE].includes(this.state.position);
    if (noAnimate || (currentlyIn && animatingOut)) {
      this.animationCallback = callback;
      return this.setState({
        animatePrepare: false,
        position,
      });
    }
    this.animationCallback = this.postPrepareAnimation;
    this.postPrepareTimeout = setTimeout(this.postPrepareAnimation, 500);
    return this.setState({
      animating: true,
      animatePrepare: true,
      position,
    });
  }

  postPrepareAnimation() {
    clearTimeout(this.postPrepareTimeout);
    this.animationCallback = null;
    this.setState({ animatePrepare: false }, () => (this.animationCallback = this.props.animationCallback));
  }

  render() {
    return (
      <div
        ref={node => (this.node = node)}
        className={classNames('router-animation', {
          'to': [Animator.TO_LEFT, Animator.TO_RIGHT, Animator.TO_FADE].includes(this.state.position),
          'from': [Animator.FROM_LEFT, Animator.FROM_RIGHT, Animator.FROM_FADE].includes(this.state.position),
          'right': [Animator.TO_RIGHT, Animator.FROM_RIGHT].includes(this.state.position),
          'left': [Animator.TO_LEFT, Animator.FROM_LEFT].includes(this.state.position),
          'fade': [Animator.TO_FADE, Animator.FROM_FADE].includes(this.state.position),
          'prepare': this.state.animatePrepare,
        })}
        data-qa-loading={Boolean(this.props['data-qa-loading'] || this.state.animating)}
      >
        <div className={this.props.className}>{this.props.children}</div>
      </div>
    );
  }
}
Animator.CENTER = 'CENTER';
Animator.TO_LEFT = 'TO_LEFT';
Animator.TO_RIGHT = 'TO_RIGHT';
Animator.FROM_LEFT = 'FROM_LEFT';
Animator.FROM_RIGHT = 'FROM_RIGHT';
Animator.TO_FADE = 'TO_FADE';
Animator.FROM_FADE = 'FROM_FADE';



// WEBPACK FOOTER //
// ./src/components/RouterAnimation/Animator.js